import { useEffect, useState } from 'react';
import React from 'react';
import './recomendado.css';
import { useTranslation } from "react-i18next";
import Popup from '../../../components/PopupGenerico/PopupGenerico';

import back_i from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';

const data = [
    {
        name: 'Stacy Herbert',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-1-Presale-poster-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-1-Presale.jpg',
    },
    {
        name: 'Stacy Herbert 2',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-2-Presale-poster-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-2-Presale.jpg',
    },
    {
        name: 'Stacy Herbert 3',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-3-Presale-poster-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-3-Presale.jpg',
    },
    {
        name: 'Stacy Herbert 4',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-4-Presale-poster-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-4-Presale.jpg',
    },
    {
        name: 'Stacy Herbert 5',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-5-Presale-poster-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-5-Presale.jpg',
    }
    // ... agrega más si quieres
];

const data2 = [
    {
        name: 'Stacy Herbert',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-1-ESP-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-1-ESP.jpg',
    },
    {
        name: 'Stacy Herbert 2',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-2-ESP-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-2-ESP.jpg',
    },
    {
        name: 'Stacy Herbert 3',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-3-ESP-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-3-ESP.jpg',
    },
    {
        name: 'Stacy Herbert 4',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-4-ESP-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-4-ESP.jpg',
    },
    {
        name: 'Stacy Herbert 5',
        position: 'Directora de la oficina Nacional del Bitcoin de El Salvador.',
        poster: '../../../assets/imgs/libro_bitcoin/Quote-5-ESP-low.jpg',
        videoUrl: '../../../assets/imgs/libro_bitcoin/Quote-5-ESP.jpg',
    }
    // ... agrega más si quieres
];


const Recomendado = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [visibleCount, setVisibleCount] = useState(3);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [cardWidth, setCardWidth] = useState(0);
    const [selectedImg, setSelectedImg] = useState(null);


    const renderPopupContent = () => {
        return (
            <div class='Pop-up-Imagen-Recomendada'>

                <img src={selectedImg} alt="Imagen recomendada" />

            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setVisibleCount(window.innerWidth <= 1150 ? 2 : 3);
            if (window.innerWidth <= 540) {
                setCardWidth(177);
            } else if (window.innerWidth <= 750) {
                setCardWidth(247);
            } else {
                setCardWidth(340);
            }
        };

        // Set on mount
        handleResize();

        // Update on resize
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleNext = () => {
        if (currentIndex + visibleCount < data.length) {
            setCurrentIndex(currentIndex + 1);
        }
    };



    return (
        <>
            <div class="landing_bitcoin_recomendado">
                <div class="landing_bitcoin_recomendado_content">
                    <h4 dangerouslySetInnerHTML={{ __html: (t('recomendado.titulo')) }}></h4>
                    <div class="landing_bitcoin_recomendado_Slider">
                        <div className="team-slider-container">
                            <div className="team-slider-viewport">
                                <div
                                    className="team-slider-track"
                                    style={{ transform: `translateX(-${currentIndex * cardWidth}px)` }}
                                >
                                    {(t('donde.btnaudio') === 'EN' ? data : data2).map((item, idx) => (
                                        <div className="team-card" key={idx}>
                                            <div className="team-image-wrapper">
                                                <a href="#" onClick={e => { e.preventDefault(); setSelectedImg(item.videoUrl); }}><img src={item.poster} alt={item.name} /></a>
                                                <button className="team-play">▶</button>
                                            </div>
                                            {/* <div className="team-footer">
                                                <strong>{item.name}</strong>
                                            </div>
                                            <div className="team-position">{item.position}</div>*/}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div id="donde-comprar" className="team-slider-controls">
                                <button onClick={handlePrev} disabled={currentIndex === 0}>←</button>
                                <button
                                    onClick={handleNext}
                                    disabled={currentIndex + visibleCount >= data.length}
                                >→</button>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="landing_bitcoin_recomendado_img_i" src={back_i}></img>
                <img class="landing_bitcoin_recomendado_img_d" src={back_d}></img>


                {selectedImg && (
                    <Popup
                        content={renderPopupContent()}
                        onClose={() => setSelectedImg(null)}
                    />
                )}


            </div>



        </>
    )
}

export default Recomendado